// Single source of truth for every domain enum (spec §5, §7, §9, §17).
// Consumed verbatim by @zebra/db, services/api and apps/web — do not fork these
// lists elsewhere. Each enum is a `readonly` tuple + derived union type so both
// runtime validation (zod `z.enum(X)`) and compile-time types stay in lockstep.
export const MOVEMENT_TYPES = [
    'RECEIPT',
    'PRODUCTION_IN',
    'PRODUCTION_OUT',
    'ISSUE',
    'DISPATCH',
    'ADJUSTMENT',
    'TRANSFER_IN',
    'TRANSFER_OUT',
    'PACK_IN',
    'PACK_OUT',
    'OPENING_BALANCE',
    'RETURN_IN',
    'RECOST',
];
export const MOVEMENT_SOURCES = ['MEASURED', 'ESTIMATED', 'DERIVED'];
export const ROLES = ['ADMIN', 'OPERATIONS', 'SALES_ACCOUNTS', 'READ_ONLY'];
export const PRODUCT_TYPES = ['RAW_MATERIAL', 'INTERMEDIATE', 'FINISHED_GOOD', 'CONSUMABLE', 'PACKAGING'];
export const BASE_UOMS = ['KG', 'EACH', 'L'];
export const VAT_TREATMENTS = ['STANDARD', 'ZERO_RATED', 'EXEMPT'];
export const LOCATION_TYPES = ['YARD', 'SILO', 'WAREHOUSE', 'BIN', 'STORE', 'KILN', 'WIP'];
/** Document-number prefixes (S2 doc-numbers seam), distinct from any status enum below. */
export const DOC_TYPES = ['PO', 'SO', 'WB', 'GR', 'LC', 'RUN', 'PC', 'DN', 'INV', 'CN', 'ADJ', 'CNT', 'ISS', 'TR'];
export const PRICING_BASES = ['FLAT_WET', 'BDT', 'MOISTURE_BAND'];
/** silo_calibrations.method (§5.2). Added per Wave 2 gate 2026-07-07 — core is the
 * canonical source; packages/db pgEnums must consume these lists, not fork them. */
export const SILO_CALIBRATION_METHODS = ['LINEAR', 'STRAPPING'];
/** silo_calibrations.density_source (§5.2). Added per Wave 2 gate 2026-07-07. */
export const SILO_DENSITY_SOURCES = ['PRODUCT', 'OVERRIDE'];
// ---- Document-status enums (spec §5) ----------------------------------------
/** purchase_orders.status (§5.4) */
export const PURCHASE_ORDER_STATUSES = ['DRAFT', 'OPEN', 'PARTIAL', 'COMPLETE', 'CANCELLED'];
/** weighbridge_tickets.status (§5.4) */
export const TICKET_STATUSES = ['DRAFT', 'POSTED', 'REVERSED'];
/** goods_receipts.status (§5.4) */
export const GOODS_RECEIPT_STATUSES = ['DRAFT', 'POSTED', 'REVERSED'];
/** production_runs.status (§5.5) */
export const PRODUCTION_RUN_STATUSES = ['OPEN', 'CLOSED', 'POSTED', 'REVERSED'];
/** dispatches.status (§5.7) */
export const DISPATCH_STATUSES = ['DRAFT', 'POSTED', 'REVERSED'];
/** invoices.status (§5.7) */
export const INVOICE_STATUSES = ['DRAFT', 'APPROVED', 'SYNCED', 'PAID', 'VOID'];
/** stock_counts.status (§5.6) */
export const STOCK_COUNT_STATUSES = ['DRAFT', 'IN_PROGRESS', 'COMPLETED', 'CANCELLED'];
//# sourceMappingURL=enums.js.map